/**
 * Portal Manta · extrairKpisDoFormatoRaso
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { extKm } from '../../globals.js';

function extrairKpisDoFormatoRaso(obj){
  const out = { _formato:'raso', _origem:[] };
  const aliases = {
    nome:    ['nome','name','titulo','projeto'],
    uf:      ['uf','estado','state'],
    cidade:  ['cidade','city','municipio'],
    extKm:   ['extKm','ext_km','extensao','extensao_km','length','comprimento'],
    dupKm:   ['dupKm','dup_km','duplicacao','duplicacao_km'],
    margKm:  ['margKm','marg_km','marginais','marginais_km'],
    fxKm:    ['fxKm','fx_km','faixas','faixa_adicional'],
    ciclKm:  ['ciclKm','cicl_km','ciclovia','ciclovias','ciclovia_km'],
    oaeQt:   ['oaeQt','oae','oaes','oae_qt','n_oae','pontes'],
    passQt:  ['passQt','pass','passarelas','pass_qt','n_pass'],
    interQt: ['interQt','inter','intersecoes','interseções','inter_qt','n_inter'],
    chuvaMM: ['chuvaMM','chuva','chuva_mm','precipitacao'],
    chuvaDias:['chuvaDias','dias_chuva','dias_chuvosos'],
  };
  // case-insensitive lookup
  const lower = {};
  for (const k of Object.keys(obj)) lower[k.toLowerCase()] = k;
  for (const [destino, candidatos] of Object.entries(aliases)){
    for (const c of candidatos){
      if (lower[c.toLowerCase()] !== undefined){
        const v = obj[lower[c.toLowerCase()]];
        if (v !== null && v !== undefined && v !== ''){
          out[destino] = ['nome','uf','cidade'].includes(destino) ? v : (parseFloat(v) || 0);
          out._origem.push(`${destino}='${v}' de chave '${lower[c.toLowerCase()]}'`);
          break;
        }
      }
    }
  }
  return out;
}

export { extrairKpisDoFormatoRaso };
export default extrairKpisDoFormatoRaso;
